import { getContainerTypes } from "../productCommons/index.js";
import type { ContainerTypeDeliveryChargeRule } from "./containerTypeDeliveryChargeRulesCommons.js";

const calculateItemsTotalPrice = (
  items: { price: number; quantity: number }[],
) => {
  return items.reduce((prev, item) => {
    return prev + item.quantity * item.price;
  }, 0);
};

export const calculateDeliveryOffers = (
  containerTypeDeliveryChargeRules: ContainerTypeDeliveryChargeRule[],
  orderItems: {
    containerType: string | null;
    quantity: number;
    price: number;
  }[],
) => {
  const rules = containerTypeDeliveryChargeRules;

  const itemsWithAllContainerTypes = orderItems.map((item) => ({
    ...item,
    containerTypes: getContainerTypes(item.containerType),
  }));

  return rules.map((rule) => {
    const applicableItems = itemsWithAllContainerTypes.filter((item) =>
      item.containerTypes.includes(rule.containerType),
    );
    const totalSpendOnContainerType = calculateItemsTotalPrice(applicableItems);
    const remainder = rule.value - totalSpendOnContainerType;
    const qualifiesForFreeDelivery = remainder <= 0;

    return {
      deliveryRule: rule,
      remainder: remainder < 0 ? 0 : remainder,
      qualifiesForFreeDelivery,
    };
  });
};
